// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
   display: block;
   height: 26px;
   margin: 0 auto 30px;
}

form {
   background-color: #fff;
   border: 1px solid rgba(0, 0, 0, .1);
   /* margin: auto; */
   padding: 30px 40px;
   position: relative;
   width: 100%;
   max-width: 440px;
   min-width: 380px;
}

.clearfix:before, .clearfix:after {
   content: " ";
   display: table;
}

form .link {
   color: #36c6d3;
   cursor: pointer;
}

form .link:hover {
   color: #337ab7;
}

.login-header {
   float: left;
   font-size: 20px;
}

.login-register {
   float: right;
   margin-top: 6px;
   margin-bottom: 1em;
}

label {
   color: #aaa;
   display: block;
   font-weight: normal;
   margin-top: .5em;
   margin-bottom: 2px;
}

.mat-form-field {
   width: 100%;
}

input[type=text], input[type=password], input[type=email] {
   border: 1px solid rgba(0, 0, 0, .1);
   border-radius: 2px;
   font-size: 16px;
   outline: none;
   padding-left: 5px;
   padding-top: 2px;
   padding-bottom: 2px;
   width: 100%;
}

input:-webkit-autofill {
   -webkit-border-start-color: #e5e5e5;
   -webkit-border-end-color: #e5e5e5;
   -webkit-border-after-color: #e5e5e5;
   -webkit-border-before-color: #e5e5e5;
   -webkit-box-shadow: 0 0 0 1000px white inset;
}

input + label {
   margin-top: 10px;
}

.forgot {
   font-size: 12px;
   margin-top: 4px;
}

.login-button {
   box-shadow: none !important;
   margin-top: 1em !important; /* !important overwrites 'margin: 0' from button.css */
   width: 100%;
}

#resetpsw {
   display: none;
}

.modal-content {
   border-color: transparent;
   border-radius: 0;
   padding: 10px 30px;
}

#resetpsw h3 {
   margin: .5em 0;
   text-align: left;
}

.forgot-instruction {
   display: block;
   text-align: left;
}

#resetpsw input {
   display: block;
   margin: 1em auto .5em;
   width: 100%;
}

/* Change styles for span and cancel button on extra small screens */
/*@media screen and (max-width: 300px) {*/
/*span.psw {*/
/*display: block;*/
/*float: none;*/
/*}*/
/*.cancelbtn {*/
/*width: 100%;*/
/*}*/

/*}*/
@media screen and (max-width: 400px) {
   .container {
      display: block;
      float: none;
      margin-top: 70px;
      width: 320px;
   }
}

/* Add padding to container elements */
.container {
   padding: 16px;
}

/* The Modal (background) */
.modal {
   display: none; /* Hidden by default */
   position: fixed; /* Stay in place */
   z-index: 100; /* Sit on top */
   left: 0;
   top: 0;
   width: 100%; /* Full width */
   height: 100%; /* Full height */
   overflow: auto; /* Enable scroll if needed */
   background-color: rgb(0, 0, 0); /* Fallback color */
   background-color: rgba(0, 0, 0, 0.2); /* Black w/ opacity */
   padding-top: 60px;
}

/* Modal Content/Box */
.modal-content {
   margin: 5% auto 15% auto; /* 5% from the top, 15% from the bottom and centered */
   width: 450px; /* Could be more or less, depending on screen size */
}

/* The Close Button (x) */
.close {
   position: absolute;
   right: 35px;
   top: 15px;
   color: #000;
   font-size: 40px;
   font-weight: bold;
}

.close:hover,
.close:focus {
   color: red;
   cursor: pointer;
}

/* Clear floats */
.clearfix::after {
   content: "";
   clear: both;
   display: table;
}

/* Change styles for cancel button and signup button on extra small screens */
@media screen and (max-width: 300px) {
   .cancelbtn, .signupbtn {
      width: 100%;
   }
}

.wait, .wait *, .wait a {
   cursor: wait;
}

p {
   width: 100%;
   margin: 0;
   padding: 0;
   text-align: center;
}

.fancy {
   margin: 2em 0;
   text-align: center;
}

.fancy span {
   display: inline-block;
   position: relative;
   text-transform: capitalize;
}

.fancy span:before,
.fancy span:after {
   border-bottom: 1px solid #ccc;
   content: "";
   position: absolute;
   top: 11px;
   max-width: 140px;
   min-width: 130px;
}

.fancy span:before {
   right: 100%;
   margin-right: 15px;
}

.fancy span:after {
   left: 100%;
   margin-left: 15px;
}

.social a {
   border: 1px solid rgba(0, 0, 0, .1);
   /*border-radius: 2px;*/
   display: block;
   line-height: 1.6em;
   padding: 5px;
   position: relative;
   text-align: center;
   transition: background-color .2s, color .2s;

   border-radius: 20px;
   /*line-height: 30px;*/
}

.social a:hover {
   cursor: pointer;
   text-decoration: none;
}

.social a.disabled {
   color: #ccc;
   cursor: default;
   text-decoration: none;
}

.social .fa:before {
   font-size: 1.6em;
   position: absolute;
}

a.fa-facebook {
   color: #3b5998;
}

a.fa-facebook:not(.disabled):hover {
   background-color: #3b5998;
   color: #fff;
}

a.fa-facebook:before {
   left: 12px;
}

a.fa-google {
   color: #dc4b3e;
}

a.fa-google:not(.disabled):hover {
   background-color: #dc4b3e;
   color: #fff;
}

a.fa-google:before {
   left: 10px;
}

a.fa-microsoft:not(.disabled):hover {
   background-color: #2db1e5;
   color: #fff;
}

.microsoft-icon {
   width: 40px;
   height: 20px;
   position: absolute;
   left: 1px;
}

.social a + a {
   margin-top: 5px;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

.idp-restricted {
   color: #e53935;
   font-size: 13px;
   line-height: 1.45;
   margin: 4px 0 14px;
}

.idp-restricted .idp-link {
   white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/login/login.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,YAAY;GACZ,mBAAmB;AACtB;;AAEA;GACG,sBAAsB;GACtB,mCAAmC;GACnC,kBAAkB;GAClB,kBAAkB;GAClB,kBAAkB;GAClB,WAAW;GACX,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,cAAc;GACd,mBAAmB;GACnB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,mCAAmC;GACnC,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,mCAAmC;GACnC,iCAAiC;GACjC,mCAAmC;GACnC,oCAAoC;GACpC,4CAA4C;AAC/C;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,2BAA2B;GAC3B,0BAA0B,EAAE,sDAAsD;GAClF,WAAW;AACd;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,yBAAyB;GACzB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,qBAAqB;GACrB,WAAW;AACd;;AAEA,oEAAoE;AACpE,yCAAyC;AACzC,aAAa;AACb,kBAAkB;AAClB,eAAe;AACf,IAAI;AACJ,eAAe;AACf,eAAe;AACf,IAAI;;AAEJ,IAAI;AACJ;GACG;MACG,cAAc;MACd,WAAW;MACX,gBAAgB;MAChB,YAAY;GACf;AACH;;AAEA,sCAAsC;AACtC;GACG,aAAa;AAChB;;AAEA,2BAA2B;AAC3B;GACG,aAAa,EAAE,sBAAsB;GACrC,eAAe,EAAE,kBAAkB;GACnC,YAAY,EAAE,eAAe;GAC7B,OAAO;GACP,MAAM;GACN,WAAW,EAAE,eAAe;GAC5B,YAAY,EAAE,gBAAgB;GAC9B,cAAc,EAAE,4BAA4B;GAC5C,8BAA8B,EAAE,mBAAmB;GACnD,oCAAoC,EAAE,qBAAqB;GAC3D,iBAAiB;AACpB;;AAEA,sBAAsB;AACtB;GACG,wBAAwB,EAAE,sDAAsD;GAChF,YAAY,EAAE,oDAAoD;AACrE;;AAEA,yBAAyB;AACzB;GACG,kBAAkB;GAClB,WAAW;GACX,SAAS;GACT,WAAW;GACX,eAAe;GACf,iBAAiB;AACpB;;AAEA;;GAEG,UAAU;GACV,eAAe;AAClB;;AAEA,iBAAiB;AACjB;GACG,WAAW;GACX,WAAW;GACX,cAAc;AACjB;;AAEA,6EAA6E;AAC7E;GACG;MACG,WAAW;GACd;AACH;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,WAAW;GACX,SAAS;GACT,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,kBAAkB;GAClB,0BAA0B;AAC7B;;AAEA;;GAEG,6BAA6B;GAC7B,WAAW;GACX,kBAAkB;GAClB,SAAS;GACT,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,kBAAkB;AACrB;;AAEA;GACG,UAAU;GACV,iBAAiB;AACpB;;AAEA;GACG,mCAAmC;GACnC,sBAAsB;GACtB,cAAc;GACd,kBAAkB;GAClB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,2CAA2C;;GAE3C,mBAAmB;GACnB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,qBAAqB;AACxB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,SAAS;AACZ;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;AACX;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,cAAc;GACd,eAAe;GACf,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB","sourcesContent":[".logo {\n   display: block;\n   height: 26px;\n   margin: 0 auto 30px;\n}\n\nform {\n   background-color: #fff;\n   border: 1px solid rgba(0, 0, 0, .1);\n   /* margin: auto; */\n   padding: 30px 40px;\n   position: relative;\n   width: 100%;\n   max-width: 440px;\n   min-width: 380px;\n}\n\n.clearfix:before, .clearfix:after {\n   content: \" \";\n   display: table;\n}\n\nform .link {\n   color: #36c6d3;\n   cursor: pointer;\n}\n\nform .link:hover {\n   color: #337ab7;\n}\n\n.login-header {\n   float: left;\n   font-size: 20px;\n}\n\n.login-register {\n   float: right;\n   margin-top: 6px;\n   margin-bottom: 1em;\n}\n\nlabel {\n   color: #aaa;\n   display: block;\n   font-weight: normal;\n   margin-top: .5em;\n   margin-bottom: 2px;\n}\n\n.mat-form-field {\n   width: 100%;\n}\n\ninput[type=text], input[type=password], input[type=email] {\n   border: 1px solid rgba(0, 0, 0, .1);\n   border-radius: 2px;\n   font-size: 16px;\n   outline: none;\n   padding-left: 5px;\n   padding-top: 2px;\n   padding-bottom: 2px;\n   width: 100%;\n}\n\ninput:-webkit-autofill {\n   -webkit-border-start-color: #e5e5e5;\n   -webkit-border-end-color: #e5e5e5;\n   -webkit-border-after-color: #e5e5e5;\n   -webkit-border-before-color: #e5e5e5;\n   -webkit-box-shadow: 0 0 0 1000px white inset;\n}\n\ninput + label {\n   margin-top: 10px;\n}\n\n.forgot {\n   font-size: 12px;\n   margin-top: 4px;\n}\n\n.login-button {\n   box-shadow: none !important;\n   margin-top: 1em !important; /* !important overwrites 'margin: 0' from button.css */\n   width: 100%;\n}\n\n#resetpsw {\n   display: none;\n}\n\n.modal-content {\n   border-color: transparent;\n   border-radius: 0;\n   padding: 10px 30px;\n}\n\n#resetpsw h3 {\n   margin: .5em 0;\n   text-align: left;\n}\n\n.forgot-instruction {\n   display: block;\n   text-align: left;\n}\n\n#resetpsw input {\n   display: block;\n   margin: 1em auto .5em;\n   width: 100%;\n}\n\n/* Change styles for span and cancel button on extra small screens */\n/*@media screen and (max-width: 300px) {*/\n/*span.psw {*/\n/*display: block;*/\n/*float: none;*/\n/*}*/\n/*.cancelbtn {*/\n/*width: 100%;*/\n/*}*/\n\n/*}*/\n@media screen and (max-width: 400px) {\n   .container {\n      display: block;\n      float: none;\n      margin-top: 70px;\n      width: 320px;\n   }\n}\n\n/* Add padding to container elements */\n.container {\n   padding: 16px;\n}\n\n/* The Modal (background) */\n.modal {\n   display: none; /* Hidden by default */\n   position: fixed; /* Stay in place */\n   z-index: 100; /* Sit on top */\n   left: 0;\n   top: 0;\n   width: 100%; /* Full width */\n   height: 100%; /* Full height */\n   overflow: auto; /* Enable scroll if needed */\n   background-color: rgb(0, 0, 0); /* Fallback color */\n   background-color: rgba(0, 0, 0, 0.2); /* Black w/ opacity */\n   padding-top: 60px;\n}\n\n/* Modal Content/Box */\n.modal-content {\n   margin: 5% auto 15% auto; /* 5% from the top, 15% from the bottom and centered */\n   width: 450px; /* Could be more or less, depending on screen size */\n}\n\n/* The Close Button (x) */\n.close {\n   position: absolute;\n   right: 35px;\n   top: 15px;\n   color: #000;\n   font-size: 40px;\n   font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n   color: red;\n   cursor: pointer;\n}\n\n/* Clear floats */\n.clearfix::after {\n   content: \"\";\n   clear: both;\n   display: table;\n}\n\n/* Change styles for cancel button and signup button on extra small screens */\n@media screen and (max-width: 300px) {\n   .cancelbtn, .signupbtn {\n      width: 100%;\n   }\n}\n\n.wait, .wait *, .wait a {\n   cursor: wait;\n}\n\np {\n   width: 100%;\n   margin: 0;\n   padding: 0;\n   text-align: center;\n}\n\n.fancy {\n   margin: 2em 0;\n   text-align: center;\n}\n\n.fancy span {\n   display: inline-block;\n   position: relative;\n   text-transform: capitalize;\n}\n\n.fancy span:before,\n.fancy span:after {\n   border-bottom: 1px solid #ccc;\n   content: \"\";\n   position: absolute;\n   top: 11px;\n   max-width: 140px;\n   min-width: 130px;\n}\n\n.fancy span:before {\n   right: 100%;\n   margin-right: 15px;\n}\n\n.fancy span:after {\n   left: 100%;\n   margin-left: 15px;\n}\n\n.social a {\n   border: 1px solid rgba(0, 0, 0, .1);\n   /*border-radius: 2px;*/\n   display: block;\n   line-height: 1.6em;\n   padding: 5px;\n   position: relative;\n   text-align: center;\n   transition: background-color .2s, color .2s;\n\n   border-radius: 20px;\n   /*line-height: 30px;*/\n}\n\n.social a:hover {\n   cursor: pointer;\n   text-decoration: none;\n}\n\n.social a.disabled {\n   color: #ccc;\n   cursor: default;\n   text-decoration: none;\n}\n\n.social .fa:before {\n   font-size: 1.6em;\n   position: absolute;\n}\n\na.fa-facebook {\n   color: #3b5998;\n}\n\na.fa-facebook:not(.disabled):hover {\n   background-color: #3b5998;\n   color: #fff;\n}\n\na.fa-facebook:before {\n   left: 12px;\n}\n\na.fa-google {\n   color: #dc4b3e;\n}\n\na.fa-google:not(.disabled):hover {\n   background-color: #dc4b3e;\n   color: #fff;\n}\n\na.fa-google:before {\n   left: 10px;\n}\n\na.fa-microsoft:not(.disabled):hover {\n   background-color: #2db1e5;\n   color: #fff;\n}\n\n.microsoft-icon {\n   width: 40px;\n   height: 20px;\n   position: absolute;\n   left: 1px;\n}\n\n.social a + a {\n   margin-top: 5px;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\n.idp-restricted {\n   color: #e53935;\n   font-size: 13px;\n   line-height: 1.45;\n   margin: 4px 0 14px;\n}\n\n.idp-restricted .idp-link {\n   white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
